export default {"src":"/_next/static/image/public/images/logo_aster_ar.d59ca4e341929f647b3be3c2059052c3.svg","height":30,"width":106};